import React from 'react';

import { InternetBanner, ProductStatus } from '@/ui/index';
import { InfoCircle, InfoQuestion } from '@/icons/index';

import Questions from '../Questions/Questions';

const BeforeTrip = ({ data }) => {
  return (
    <div itemScope itemType='http://schema.org/Product'>
      {data?.mainBanner && <InternetBanner bannerData={data.mainBanner} />}
      {data?.productStatus && (
        <ProductStatus
          statusData={data.productStatus}
          className='wrapper small-margin'
          isBlock
          titleModify='title--large'
          Icon={InfoQuestion}
        />
      )}
      {data?.questions && (
        <Questions
          questions={data.questions}
          Icon={InfoCircle}
          titleModify='title--large'
          className='wrapper section'
        />
      )}
    </div>
  );
};

export default BeforeTrip;
